import React, { Fragment, useCallback, useEffect, useState } from 'react';
import {
  BaseContainer,
  // BreakHack,
  Button,
  // ButtonLookLikeHref,
  // ButtonsContainer,
  InputContainer,
  NameInput,
  PersText,
  PhoneInput,
  Popup,
  // RequestButton,
  Text,
  // Title,
} from './styled';
// import {
//   ESendByCallPetitions,
//   sendByCall,
// } from '~/src/api/service-request/by-call';
import { connect } from 'react-redux';
import { selectDomain } from '~/src/store/selectors/domain';
import { TState } from '~/src/store';
import { requestByCallByOms } from '~/src/api/service-request/request-by-call-by-oms';
import RenderMessage from '~/src/components/Popups/CallRequestByTheme/RenderMessage';
import { ACTIONS } from '~/src/constants/analytics';
import { dataLayerForCBPhonePush } from '~/src/helpers/eventsForDataLayer';
import { TField } from '~/src/components/RequestForm';
// @ts-ignore
// import { CreatablePhoneSelect } from '@stelecom/ui-react/components/select/creatableSelect';
// import { getContacts } from '~/src/api/profile/getContacts';
// import PopupNoWork from '~/src/components/Popups/NoWorkExcuses/popupExcuses';

enum EThemes {
  PROBLEMS_REPORT,
  GET_CONSULTATION,
  BECOME_CLIENT,
  COMPLAIN,
  OTHER,
}

interface ITheme {
  code: EThemes;
  label: string;
  isHighlight?: boolean;
  inProcess: boolean;
}

// const INITIAL_THEME = -1;

const THEMES: ITheme[] = [
  {
    code: EThemes.PROBLEMS_REPORT,
    label: 'сообщить о неполадках',
    inProcess: true,
  },
  {
    code: EThemes.GET_CONSULTATION,
    label: 'получить консультацию',
    inProcess: false,
  },
  {
    code: EThemes.COMPLAIN,
    label: 'пожаловаться',
    inProcess: true,
  },
  {
    code: EThemes.OTHER,
    label: 'другое',
    inProcess: true,
  },
];

interface IInputValue {
  readonly isValid: boolean;
  readonly value: string;
  readonly clearInput?: () => void;
}


function useIsValidForm(fio: IInputValue, phone: IInputValue, inputPhone: any): [boolean] {
  const [isValid, setIsValid] = useState<boolean>(false);
  useEffect(() => {
    // @ts-ignore
    if (phone.value === -1) {
      const res = phone.value === -1 && inputPhone.length >= 11;
      setIsValid(fio.isValid && res);
    } else {
      setIsValid(fio.isValid && phone.isValid);
    }
  }, [fio, phone, inputPhone]);
  return [isValid];
}

/**
 * @param state
 */
function mapStateToProps(state: TState) {
  return {
    domain: selectDomain(state),
    cityId: state.city.currentCity.cityId,
    accessToken: state.auth.accessToken,
  };
}

export default connect(mapStateToProps)(CallRequestByTheme);

function clearFields(fields: IInputValue[]): void {
  fields.forEach(function(field) {
    if (field.clearInput) {
      field.clearInput();
    }
  });
}

interface CallRequestByThemeProps {
  isAuth: boolean;
  isOpen: boolean;
  onClose: () => void;
  domain: string;
  cityId: number | string;
  accessToken: string;
}

function CallRequestByTheme({
  isAuth,
  isOpen,
  onClose,
  domain,
  cityId,
  accessToken,
}: CallRequestByThemeProps) {
  const theme = THEMES[1];
  // const [theme, setTheme] = useState<ITheme>(THEMES[+INITIAL_THEME]);
  // const [selectBlockVisible, setVisible] = useState<boolean>(true);
  // const [isHighlight, setHighlight] = useState<number>(-1);
  const [fio, setFio] = useState<IInputValue>({ value: '', isValid: false });
  const [phone, setPhone] = useState<IInputValue>({
    value: '',
    isValid: false,
  });
  const [inputPhone, setInputPhone] = useState<any>({
    value: '',
    isValid: false,
  });
  const [clearTimeoutLink, setClearTimeout] = useState<number | null>(null);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [message, setMessage] = useState<string | null | undefined>(null);
  // @ts-ignore
  const [isValid] = useIsValidForm(fio, phone, inputPhone);

  // @TODO заплатка - потому что clearFields не очищает phone
  const clearFieldsPatch = () => {
    setFio({ value: '', isValid: false });
    setPhone({ value: '', isValid: false });
  };

  const handleClose = useCallback(() => {
    // setVisible(true);
    // setHighlight(INITIAL_THEME);
    setIsError(false);
    setMessage(null);
    clearFields([fio, phone]);
    clearFieldsPatch();
    if (clearTimeoutLink) {
      clearTimeout(clearTimeoutLink);
    }
    onClose();
  }, [fio, phone, clearTimeoutLink]);

  const handleSendRequest = useCallback(async() => {
    if (theme) {
      setIsError(false);
      setMessage(null);
      if (clearTimeoutLink) {
        clearTimeout(clearTimeoutLink);
      }
      setIsLoading(true);
      setMessage(null);

      // let resp;
      // if (theme.code === EThemes.BECOME_CLIENT) {
      //   resp = await sendByCall(domain, {
      //     fio: fio.value,
      //     phone: phone.value,
      //     petition: ESendByCallPetitions.RequestNew,
      //   });
      // } else {
      // @ts-ignore
      const phoneToSend = phone.value === -1 ? inputPhone : phone.value;
      const resp = await requestByCallByOms(phoneToSend, cityId);
      // }

      dataLayerForCBPhonePush({
        action: resp.status ? ACTIONS.finished : ACTIONS.error,
        requestId: null,
        option: `${theme.label}`,
        isPopup: true,
      });

      clearFields([fio, phone]);
      clearFieldsPatch();

      setIsLoading(false);
      if (resp.status === 1) {
        setIsError(false);
        if (resp.message) {
          setMessage(resp.message);
        } else {
          setMessage('Заявка успешно создана');
        }
      } else {
        setIsError(true);
        if (resp.message == null) {
          setMessage(undefined);
        } else {
          setMessage(resp.message);
        }
      }
      setClearTimeout(
        setTimeout(() => {
          setIsError(false);
          setMessage(null);
        }, 30000) as unknown as number
      );
    }
  }, [domain, fio, phone, theme, clearTimeoutLink, cityId]);

  // const onSelectHandler = (theme: ITheme, index: number) => {
  //   setVisible(false);
  //   setTheme(theme);
  //   setHighlight(index);
  // };

  // const onChangeHandler = () => {
  //   setVisible(true);
  //   clearFieldsPatch();
  // };

  return (
    <Popup isOpen={isOpen} onClose={handleClose}>
      {/* {selectBlockVisible
        ? <RenderSelectTheme
            themes={THEMES}
            HighlightIndex={isHighlight}
            onSelectTheme={onSelectHandler}
          /> */}
      {isAuth
        ? <RenderFormAuth
          domain={domain}
          accessToken={accessToken}
          fio={fio}
          // onChangeTheme={onChangeHandler}
          onEditFio={setFio}
          onEditPhone={setPhone}
          onEditInputPhone={setInputPhone}
          message={message}
          onSendRequest={handleSendRequest}
          phone={phone}
          inputPhone={inputPhone}
          theme={theme}
          isValid={isValid}
          isLoading={isLoading}
          isError={isError}
        />
        : <RenderForm
          domain={domain}
          accessToken={accessToken}
          fio={fio}
          // onChangeTheme={onChangeHandler}
          onEditFio={setFio}
          onEditPhone={setPhone}
          message={message}
          onSendRequest={handleSendRequest}
          phone={phone}
          theme={theme}
          isValid={isValid}
          isLoading={isLoading}
          isError={isError}
        />
      }
    </Popup>
  );
}

// interface IRenderSelect {
//   themes: ITheme[];
//   HighlightIndex: number | boolean;
//   onSelectTheme: (theme: ITheme, index: number) => void;
// }

// function RenderSelectTheme({
//   themes,
//   onSelectTheme,
//   HighlightIndex,
// }: IRenderSelect) {
//   const [isCallbackOpen, setIsCallbackOpen] = useState<boolean>(false);

//   return (
//     <Fragment>
//       <Title>Выберите тему обращения</Title>
//       <PopupNoWork isOpen={isCallbackOpen} onClose={() => setIsCallbackOpen(false)}/>
//       <ButtonsContainer>
//         {themes.map(function(theme, index) {
//           return (
//             <RequestButton
//               key={theme.code}
//               onClick={() => {
//                 !theme.inProcess
//                     ? onSelectTheme(theme, index)
// : setIsCallbackOpen(!isCallbackOpen);
//               }}
//               isHighlight={HighlightIndex === index}
//             >
//               {theme.label}
//             </RequestButton>
//           );
//         })}
//       </ButtonsContainer>
//     </Fragment>
//   );
// }

interface IRenderFormPropsNotAuth {
  readonly domain: string,
  readonly accessToken: string,
  readonly theme: ITheme;
  readonly fio: IInputValue;
  readonly phone: IInputValue;
  readonly onEditFio: (fio: IInputValue) => void;
  readonly onEditPhone: (phone: IInputValue) => void;
  // readonly onChangeTheme: () => void;
  readonly onSendRequest: () => void;
  readonly isValid: boolean;
  readonly isLoading: boolean;
  readonly isError: boolean;
  readonly message: string | null | undefined;
}

function RenderForm({
  theme,
  fio,
  phone,
  onEditFio,
  onEditPhone,
  // onChangeTheme,
  onSendRequest,
  isValid,
  isLoading,
  isError,
  message,
}: IRenderFormPropsNotAuth) {
  const [beenStarted, setDataLayer] = useState(false);

  const onChangeHandler = useCallback(
    (stateInput: IInputValue, _setState: (value: IInputValue) => void) => {

      const stateResult =
        typeof stateInput === 'object' ? stateInput.value : stateInput;
      // @TODO stateInput.value убрать из условия после фикса nameDecorator (useEffect onchange) UI react
      if (!beenStarted && stateResult) {
        dataLayerForCBPhonePush({
          action: ACTIONS.started,
          requestId: null,
          option: `${theme.label}`,
          isPopup: true,
        });
        setDataLayer(true);
      }
      _setState(stateInput);
    },
    [beenStarted, theme.label]
  );

  return (
    <Fragment>
      {/* <Title>Тема обращения: {theme.label}</Title> */}
      <Text>
        Оставьте номер телефона, и менеджер вам перезвонит.
        {/* <BreakHack>
          {' '}
          Или
          <ButtonLookLikeHref onClick={onChangeTheme}>
            измените тему обращения
          </ButtonLookLikeHref>
          .
        </BreakHack> */}
      </Text>
      <InputContainer>
        <NameInput
          initialValue={fio.value}
          onChange={(stateInput: TField) =>
            onChangeHandler(stateInput, onEditFio)
          }
          placeholder={'Ваше имя'}
          errorMessage={'Ожидаются только буквы и дефисы'}
        />
        <PhoneInput
            initialValue={phone.value}
            onChange={(stateInput: TField) =>
                onChangeHandler(stateInput, onEditPhone)
            }
            placeholder={'Номер телефона'}
            errorMessage={'Введите телефон в формате +7 (999) 999-99-99'}
        />

      </InputContainer>

      <RenderMessage isError={isError} message={message} />

      <BaseContainer w100={true}>
        <Button onClick={onSendRequest} disabled={!isValid || isLoading}>
          Отправить заявку
        </Button>
        <PersText>
          Нажимая кнопку, вы даёте согласие на обработку{' '}
          <a
            href='https://stelecom.ru/voprosy-i-otvety/dokumenty/'
            target='_blank'
            rel='noopener noreferrer'
          >
            персональных данных
          </a>
        </PersText>
      </BaseContainer>
    </Fragment>
  );
}

// TODO поменять типы
// function phoneListToOptions(phoneList: any) {
//   return phoneList.map(function(item : any) {
//     return {
//       isValid: true,
//       value: item.id,
//       label: item.value,
//     };
//   });
// }

interface IRenderFormProps extends IRenderFormPropsNotAuth{
  readonly inputPhone: any;
  readonly onEditInputPhone: (inputPhone: any) => void;
}

function RenderFormAuth({
  // domain,
  // accessToken,
  theme,
  fio,
  phone,
  // inputPhone,
  onEditFio,
  onEditPhone,
  // onEditInputPhone,
  // onChangeTheme,
  onSendRequest,
  isValid,
  isLoading,
  isError,
  message,
}: IRenderFormProps) {
  const [beenStarted, setDataLayer] = useState(false);
  // const [phoneList, setPhoneList] = useState([]);

  const onChangeHandler = useCallback(
      (stateInput: IInputValue, _setState: (value: IInputValue) => void) => {

        const stateResult =
            typeof stateInput === 'object' ? stateInput.value : stateInput;
        // @TODO stateInput.value убрать из условия после фикса nameDecorator (useEffect onchange) UI react
        if (!beenStarted && stateResult) {
          dataLayerForCBPhonePush({
            action: ACTIONS.started,
            requestId: null,
            option: `${theme.label}`,
            isPopup: true,
          });
          setDataLayer(true);
        }
        _setState(stateInput);
      },
      [beenStarted, theme.label]
  );

  // useEffect(() => {
  //   if (accessToken) {
  //   getContacts(domain, accessToken)
  //       .then(result => {
  //         const phones = result.phones.filter(
  //             item => item.status === 'confirmed'
  //         );
  //         setPhoneList(phoneListToOptions(phones));
  //       });
  //   }
  // }, []);

  return (
      <Fragment>
        {/* <Title>Тема обращения: {theme.label}</Title> */}
        <Text>
          Оставьте номер телефона, и менеджер вам перезвонит.
          {/* <BreakHack>
            {' '}
            Или
            <ButtonLookLikeHref onClick={onChangeTheme}>
              измените тему обращения
            </ButtonLookLikeHref>
            .
          </BreakHack> */}
        </Text>
        <InputContainer w100={true}>
          <NameInput
              initialValue={fio.value}
              onChange={(stateInput: TField) =>
                  onChangeHandler(stateInput, onEditFio)
              }
              placeholder={'Ваше имя'}
              errorMessage={'Ожидаются только буквы и дефисы'}
          />
            {/* <CreatablePhoneSelect
              options={phoneList}
              onChange={(stateInput: TField) =>
                  onChangeHandler(stateInput, onEditPhone)}
              value={phone}
              inputValue={inputPhone.value}
              onInputChange={onEditInputPhone}
              type={'phone'}
              notSimple =  {true}
              placeholder={'Номер телефона'}
              inputPlaceHolder={'Номер телефона'}
              height={true}
              errorMessage={'Введите телефон в формате +7 (999) 999-99-99'}
          />*/}
          <PhoneInput
              initialValue={phone.value}
              onChange={(stateInput: TField) =>
                  onChangeHandler(stateInput, onEditPhone)
              }
              placeholder={'Номер телефона'}
              errorMessage={'Введите телефон в формате +7 (999) 999-99-99'}
          />

        </InputContainer>

        <RenderMessage isError={isError} message={message} />

        <BaseContainer w100={true}>
          <Button onClick={onSendRequest} disabled={!isValid || isLoading}>
            Отправить заявку
          </Button>
          <PersText>
            Нажимая кнопку, вы даёте согласие на обработку{' '}
            <a
                href='https://stelecom.ru/voprosy-i-otvety/soglasie-na-obrabotku/'
                target='_blank'
                rel='noopener noreferrer'
            >
              персональных данных
            </a>
          </PersText>
        </BaseContainer>
      </Fragment>
  );
}
